import { render, staticRenderFns } from "./CheckboxList.vue?vue&type=template&id=3b086650&scoped=true&lang=pug&"
import script from "./CheckboxList.vue?vue&type=script&lang=js&"
export * from "./CheckboxList.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxList.vue?vue&type=style&index=0&id=3b086650&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b086650",
  null
  
)

export default component.exports